import {useCallback, useEffect} from 'react';
import {isRouteErrorResponse} from 'react-router';

import {DEBUG} from '@/shared/config';
import {localize} from '@/shared/services/i18n';
import {logger} from '@/shared/services/logger';

type AppErrorProps = {
  error: Error | null | unknown;
};

const AppError = ({error}: AppErrorProps) => {
  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    logger.critical(`App crashed: ${String(error)}`, {
      error,
      errorMessage: String(error),
      isRouteErrorResponse: isRouteErrorResponse(error),
      stack: error instanceof Error ? error?.stack : undefined,
    });
  }, [error]);

  if (DEBUG) {
    throw error;
  }

  return (
    <div className="not-found flex h-screen w-screen flex-col items-center justify-center bg-white">
      <h2 className="mb-4 font-bold text-2xl text-error">
        {localize('app_crashed_error')}
      </h2>
      <button
        onClick={handleReload}
        className="rounded border-1 bg-white px-4 py-2"
      >
        {localize('reload')}
      </button>
    </div>
  );
};

export default AppError;
